import React from "react";
import MarketingLayout from "./components/MarketingLayout.js";

export default function About() {
  return (
    <MarketingLayout>
      <div className="marketing-page-content about-page">
        <header className="marketing-page-intro">
          <p className="marketing-page-eyebrow">Company</p>
          <h1>About</h1>
          <p className="page-lead">
            Zolaid is a product where a person types a goal and Zolaid does the work on the computer. That work includes websites, slides, and video.
          </p>
        </header>

        <section className="marketing-section-card" aria-labelledby="contact-heading">
          <h2 id="contact-heading" className="marketing-section-title">Contact</h2>
          <p className="marketing-section-text">
            <a href="mailto:hello@zolaid.com" className="contact-link">hello@zolaid.com</a>
          </p>
        </section>
      </div>
    </MarketingLayout>
  );
}
